import React, { useEffect, useRef } from "react";
import { compose } from "redux";
import { withRouter } from "react-router";
import withRegisterForm from "../../../../../hocs/withRegisterForm";
import withRegisterModal from "../../../../../hocs/withRegisterModal";
import withTranslations from "../../../../../hocs/withTranslations";
import withUserData from "../../../../../hocs/withUserData";
import { getLoginWithRedirectUrl } from "../../../../../lib/auth/authRedirectUrl";
import { getRegisterOtpNavigationState } from "../../../../../lib/auth/loginOtpNavigationState";
import { UrlProvider } from "../../../../../api/UrlProvider";
import AuthGdprFooter from "../../../auth/AuthPageLayout/components/AuthGdprFooter";
import AnalyticsEventTracker from "../../../../../lib/AnalyticsEventTracker";
import InvisibleReCaptcha from "../../../common/InvisibleReCaptcha";
import NewModal from "../../NewModal";
import NewRegisterFormContent from "../../../auth/NewRegisterFormContent";

function SquaberRegisterModal({
  translate,
  hideModal,
  locale,
  history,
  userData,
  formBuilder,
  registerLoading,
  register,
  validationErrors,
  clearValidationError,
  trigger
}) {
  const registerFormRef = useRef(null);
  const reCaptchaRef = useRef(null);

  useEffect(() => {
    AnalyticsEventTracker.trackRegistrationModalEvent(trigger || "user_action");
  }, [trigger]);

  useEffect(() => {
    if (userData) {
      hideModal();
    }
  }, [userData, hideModal]);

  const handleRegister = async () => {
    const recaptcha = await reCaptchaRef.current?.executeAsync?.();

    if (!recaptcha) {
      return;
    }

    register({
      fields: formBuilder.fields,
      recaptcha,
      hideModal,
      onSuccess: () => {
        history.push(
          UrlProvider.getUrl("fe.loginOtp", { locale }),
          getRegisterOtpNavigationState(formBuilder.fields)
        );
      }
    });
  };

  return (
    <>
      <NewModal
        title={translate("auth_register-page_title")}
        subtitle={translate("auth_register-page_subtitle")}
        cancelButtonText={translate("auth_register-page_login-link")}
        acceptButtonText={translate("auth_register-page_submit")}
        acceptButtonDisabled={registerLoading}
        acceptButtonLoading={registerLoading}
        hideOnAccept={false}
        hideOnCancel
        onCancel={() => {
          history.push(getLoginWithRedirectUrl({ locale }));
        }}
        onAccept={() => {
          registerFormRef.current?.submit();
        }}
        hideModal={hideModal}
      >
        <NewRegisterFormContent
          formRef={registerFormRef}
          formBuilder={formBuilder}
          registerLoading={registerLoading}
          validationErrors={validationErrors}
          clearValidationError={clearValidationError}
          locale={locale}
          showLoginLink={false}
          showSubmitButton={false}
          onSubmit={handleRegister}
        />
        <AuthGdprFooter />
      </NewModal>
      <InvisibleReCaptcha ref={reCaptchaRef} />
    </>
  );
}

export default compose(
  withRouter,
  withRegisterForm,
  withRegisterModal,
  withTranslations,
  withUserData
)(SquaberRegisterModal);
